// https://vanillajstoolkit.com/helpers/decodehtml/
function decodeHTML(html) {
    let txt = document.createElement('textarea');
    txt.innerHTML = html;
    const decodedHTML = txt.value;
    txt.remove();
    return decodedHTML;
}

export default decodeHTML;